import axios from '../../../../shared/axios';
import { Dispatch, Action } from 'redux';
import { saveAs } from 'file-saver';
import * as actionTypes from '../constants/actionTypes';
import {
  CreateNoteRequest, ReplyNoteRequest,
  NotesControlConfig, NotesPageRequest
} from '../../../../shared/models';

const getNotesControlConfigStart = () => {
  return {
    type: actionTypes.GET_NOTES_CONTROL_CONFIG_START,
  };
};

const getNotesControlConfigSuccess = (data: any) => {
  return {
    type: actionTypes.GET_NOTES_CONTROL_CONFIG_SUCCESS,
    data: data,
  };
};

const getNotesControlConfigFail = (error: any) => {
  return {
    type: actionTypes.GET_NOTES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const getNotesControlConfig = () => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(getNotesControlConfigStart());
      const url = `/notes/get-notes-control-configuration`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getNotesControlConfigSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getNotesControlConfigFail(err));
          reject(err);
        });
    });
  };
};

const saveNotesControlConfigStart = () => {
  return {
    type: actionTypes.SAVE_NOTES_CONTROL_CONFIG_START,
  };
};

const saveNotesControlConfigSuccess = (data: any) => {
  return {
    type: actionTypes.SAVE_NOTES_CONTROL_CONFIG_SUCCESS,
    data: data,
  };
};

const saveNotesControlConfigFail = (error: any) => {
  return {
    type: actionTypes.SAVE_NOTES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const saveNotesControlConfig = (controlConfig: NotesControlConfig) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(saveNotesControlConfigStart());
    const url = `/notes/save-notes-control-configuration`;

    axios
      .post(url, { config: controlConfig })
      .then((response) => dispatch(saveNotesControlConfigSuccess(response.data)))
      .catch((err) => dispatch(saveNotesControlConfigFail(err)));
  };
};

const getNotesStart = () => {
  return {
    type: actionTypes.GET_NOTES_START,
  };
};

const getNotesSuccess = (data: any) => {
  return {
    type: actionTypes.GET_NOTES_SUCCESS,
    data: data,
  };
};

const getNotesFail = (error: any) => {
  return {
    type: actionTypes.GET_NOTES_FAIL,
    error: error,
  };
};

export const getNotes = (pageRequest: NotesPageRequest) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(getNotesStart());
    const url = `/notes/get-notes`;

    axios
      .post(url, pageRequest)
      .then((response) => dispatch(getNotesSuccess(response.data)))
      .catch((err) => dispatch(getNotesFail(err)));
  };
};

const getNotesFileAssociationsStart = () => {
  return {
    type: actionTypes.GET_NOTES_FILE_ASSOCIATIONS_START,
  };
};

const getNotesFileAssociationsSuccess = (data: any) => {
  return {
    type: actionTypes.GET_NOTES_FILE_ASSOCIATIONS_SUCCESS,
    data: data,
  };
};

const getNotesFileAssociationsFail = (error: any) => {
  return {
    type: actionTypes.GET_NOTES_FILE_ASSOCIATIONS_FAIL,
    error: error,
  };
};

export const getNotesFileAssociations = (noteIds: string[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(getNotesFileAssociationsStart());
    const url = `/notes/get-notes-file-associations`;

    axios
      .post(url, { noteIds })
      .then((response) => dispatch(getNotesFileAssociationsSuccess(response.data)))
      .catch((err) => dispatch(getNotesFileAssociationsFail(err)));
  };
};

const clearNotesSuccess = () => {
  return {
    type: actionTypes.CLEAR_NOTES_SUCCESS,
    data: null,
  };
};

const clearNotesStart = () => {
  return {
    type: actionTypes.CLEAR_NOTES_START,
  };
};

export const clearNotes = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(clearNotesStart());
    dispatch(clearNotesSuccess());
  };
};

const getAllTruckingCompaniesStart = () => {
  return {
    type: actionTypes.GET_ALL_TRUCKING_COMPANIES_START,
  };
};

const getAllTruckingCompaniesSuccess = (data: any) => {
  return {
    type: actionTypes.GET_ALL_TRUCKING_COMPANIES_SUCCESS,
    data: data,
  };
};

const getAllTruckingCompaniesFail = (error: any) => {
  return {
    type: actionTypes.GET_ALL_TRUCKING_COMPANIES_FAIL,
    error: error,
  };
};

export const getAllTruckingCompanies = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(getAllTruckingCompaniesStart());
    const url = `/notes/get-all-trucking-companies`;

    axios
      .get(url)
      .then((response) => dispatch(getAllTruckingCompaniesSuccess(response.data)))
      .catch((err) => dispatch(getAllTruckingCompaniesFail(err)));
  };
};

const createNoteStart = () => {
  return {
    type: actionTypes.CREATE_NOTE_START,
  };
};

const createNoteSuccess = (data: any) => {
  return {
    type: actionTypes.CREATE_NOTE_SUCCESS,
  };
};

const createNoteFail = (error: any) => {
  return {
    type: actionTypes.CREATE_NOTE_FAIL,
    error: error,
  };
};

export const createNote = (formData: CreateNoteRequest) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(createNoteStart());
      const url = `/notes/create-note`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(createNoteSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(createNoteFail(err));
          reject(err);
        });
    });
  };
};

const assignNoteToTaskStart = () => {
  return {
    type: actionTypes.ASSIGN_NOTE_TO_TASK_START,
  };
};

const assignNoteToTaskSuccess = (data: any) => {
  return {
    type: actionTypes.ASSIGN_NOTE_TO_TASK_SUCCESS,
  };
};

const assignNoteToTaskFail = (error: any) => {
  return {
    type: actionTypes.ASSIGN_NOTE_TO_TASK_FAIL,
    error: error,
  };
};

export const assignNoteToTask = (formData: any) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(assignNoteToTaskStart());
      const url = `/notes/assign-note-to-task`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(assignNoteToTaskSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(assignNoteToTaskFail(err));
          reject(err);
        });
    });
  };
};

const createNoteCommentStart = () => {
  return {
    type: actionTypes.CREATE_NOTE_COMMENT_START,
  };
};

const createNoteCommentSuccess = (data: any) => {
  return {
    type: actionTypes.CREATE_NOTE_COMMENT_SUCCESS,
  };
};

const createNoteCommentFail = (error: any) => {
  return {
    type: actionTypes.CREATE_NOTE_COMMENT_FAIL,
    error: error,
  };
};

export const createNoteComment = (formData: ReplyNoteRequest) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(createNoteCommentStart());
      const url = `/notes/reply-note`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(createNoteCommentSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(createNoteCommentFail(err));
          reject(err);
        });
    });
  };
};

const archiveNoteStart = () => {
  return {
    type: actionTypes.ARCHIVE_NOTE_START,
  };
};

const archiveNoteSuccess = (data: any) => {
  return {
    type: actionTypes.ARCHIVE_NOTE_SUCCESS,
  };
};

const archiveNoteFail = (error: any) => {
  return {
    type: actionTypes.ARCHIVE_NOTE_FAIL,
    error: error,
  };
};

export const archiveNote = (id: string, archive: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(archiveNoteStart());
      const url = `/notes/archive-note-change`;

      const formData = {
        id: id,
        archive: archive,
      };

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(archiveNoteSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(archiveNoteFail(err));
          reject(err);
        });
    });
  };
};

const toggleNotePinStart = () => {
  return {
    type: actionTypes.TOGGLE_NOTE_PIN_START,
  };
};

const toggleNotePinSuccess = (data: any) => {
  return {
    type: actionTypes.TOGGLE_NOTE_PIN_SUCCESS,
  };
};

const toggleNotePinFail = (error: any) => {
  return {
    type: actionTypes.TOGGLE_NOTE_PIN_FAIL,
    error: error,
  };
};

export const toggleNotePin = (id: string, pin: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(toggleNotePinStart());
      const url = `/notes/toggle-note-pin`;

      const formData = {
        noteId: id,
        pin: pin,
      };

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(toggleNotePinSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(toggleNotePinFail(err));
          reject(err);
        });
    });
  };
};

const reassignNoteStart = () => {
  return {
    type: actionTypes.REASSIGN_NOTE_START,
  };
};

const reassignNoteSuccess = (data: any) => {
  return {
    type: actionTypes.REASSIGN_NOTE_SUCCESS,
  };
};

const reassignNoteFail = (error: any) => {
  return {
    type: actionTypes.REASSIGN_NOTE_FAIL,
    error: error,
  };
};

export const reassignNote = (formData: any) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(reassignNoteStart());
      const url = `/notes/reassign-note`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(reassignNoteSuccess(response.data));
          resolve(response);
        })
        .catch((err) => {
          dispatch(reassignNoteFail(err));
          reject(err);
        });
    });
  };
};

const exportNotesToPdfStart = () => {
  return {
    type: actionTypes.EXPORT_NOTES_TO_PDF_START,
  };
};

const exportNotesToPdfSuccess = () => {
  return {
    type: actionTypes.EXPORT_NOTES_TO_PDF_SUCCESS,
  };
};

const exportNotesToPdfFail = (error: any) => {
  return {
    type: actionTypes.EXPORT_NOTES_TO_PDF_FAIL,
    error: error,
  };
};

export const exportNotesToPdf = (notesPageRequest: NotesPageRequest, fileName: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(exportNotesToPdfStart());
    const url = `/notes/export-notes-to-pdf?fileName=${fileName}`;

    notesPageRequest.ignorePaging = true;

    axios
      .post(url, notesPageRequest, { responseType: 'blob' })
      .then((response) => {
        dispatch(exportNotesToPdfSuccess());
        saveAs(response.data, fileName);
      })
      .catch((err) => dispatch(exportNotesToPdfFail(err)));
  };
};

const exportNotesToExcelStart = () => {
  return {
    type: actionTypes.EXPORT_NOTES_TO_EXCEL_START,
  };
};

const exportNotesToExcelSuccess = () => {
  return {
    type: actionTypes.EXPORT_NOTES_TO_EXCEL_SUCCESS,
  };
};

const exportNotesToExcelFail = (error: any) => {
  return {
    type: actionTypes.EXPORT_NOTES_TO_EXCEL_FAIL,
    error: error,
  };
};

export const exportNotesToExcel = (notesPageRequest: NotesPageRequest, fileName: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(exportNotesToExcelStart());
    const url = `/notes/export-notes-to-excel?fileName=${fileName}`;

    notesPageRequest.ignorePaging = true;

    axios
      .post(url, notesPageRequest, { responseType: 'blob' })
      .then((response) => {
        dispatch(exportNotesToExcelSuccess());
        saveAs(response.data, fileName);
      })
      .catch((err) => dispatch(exportNotesToExcelFail(err)));
  };
};

// App Internal state management

const addNoteModalStateChangeSuccess = (opened: boolean) => {
  return {
    type: actionTypes.ADD_NOTE_MODAL_STATE_CHANGE,
    data: opened,
  };
};

export const addNoteModalStateChange = (opened: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(addNoteModalStateChangeSuccess(opened));
  };
};

const updateNoteStart = () => {
  return {
    type: actionTypes.UPDATE_NOTE_START,
  };
};

const updateNoteSuccess = (data: any) => {
  return {
    type: actionTypes.UPDATE_NOTE_SUCCESS,
  };
};

const updateNoteFail = (error: any) => {
  return {
    type: actionTypes.UPDATE_NOTE_FAIL,
    error: error,
  };
};

export const updateNote = (params: any) => {
  return (dispatch: Dispatch<Action>) => {
    return new Promise<any>((resolve, reject) => {
      dispatch(updateNoteStart());
      const url = `/notes/make-sticky`;

      axios
        .get(url, {
          params: params,
        })
        .then((response) => {
          dispatch(updateNoteSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(updateNoteFail(err));
          reject(err);
        });
    });
  };
};
